import { t } from 'i18next';

import { AlternateOrderValidationWarning } from 'quotes/enums';

interface IInactiveProjectLinkWarningTexts {
  action: string;
  warning: string;
}

export const isInactiveProjectLinkWarning = (
  code?: string
): code is AlternateOrderValidationWarning =>
  AlternateOrderValidationWarning.INACTIVE_BILL_TO_PROJECT_LINK === code ||
  AlternateOrderValidationWarning.INACTIVE_SHIP_TO_PROJECT_LINK === code;

export const getInactiveProjectLinkWarningTexts = (
  code: AlternateOrderValidationWarning
): IInactiveProjectLinkWarningTexts =>
  AlternateOrderValidationWarning.INACTIVE_BILL_TO_PROJECT_LINK === code
    ? {
        warning: t('warningOrderPartValidationInactiveBillToProjectLink'),
        action: t('warningOrderPartValidationInactiveBillToProjectLinkAction'),
      }
    : {
        warning: t('warningOrderPartValidationInactiveShipToProjectLink'),
        action: t('warningOrderPartValidationInactiveShipToProjectLinkAction'),
      };
